module.exports = __webpack_public_path__ + "media/img/vca/sponsors/motionartspace-00500b1b619c8a78fcfc3c0223d09052.png";